module.exports = __webpack_public_path__ + "static/media/background.006c2e6a.png";